export function keyGenerator(index: number): () => string {
  let count = 0
  return () => `${index}-${count++}`
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/react-utils.js